/** клик по иконке - делаем активным input */
$( document ).ready(function() {
    var now = new Date();
    $( "._click_ico" ).click(function() {
        var focus = $(this).attr('data-focus');
        $("._click_ico_"+focus).val(now.toLocaleDateString()).focus();
    });
});